//@todo refactor GAService to DataLayerService and move it to global
export default class GAService {
    static sendRegistrationEvent(trialToken) {
        if (trialToken !== null && trialToken.length > 0) {
            GAService.sendEvent('User', 'Register', 'Registration_Submitted_From_Trial', {'eventToken': trialToken});
        } else {
            GAService.sendEvent('User', 'Register', 'Registration_Submitted');
        }
    }

    static sendRegistrationFailedEvent(errorCode) {
        GAService.sendEvent('User', 'Register_Failed', errorCode);
    }

    static sendEvent(category, action, label, additionalData) {
        if (window.dataLayer) {
            let eventObj = {
                'event': 'GAEvent',
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label
            };

            if (typeof additionalData !== 'undefined') {
                for (let key in additionalData) {
                    if (additionalData.hasOwnProperty(key)) eventObj[key] = additionalData[key];
                }
            }

            window.dataLayer.push(eventObj);
            // debug
            // console.log(`GAService: Sent event cat:${category} act:${action} lab:${label}`);
        }
    }
}